import {Component, Input, OnInit} from '@angular/core';
import {Students} from "../../elements.types";

@Component({
  selector: 'as-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})

export class AvatarComponent implements OnInit {

  @Input() student: Students;
  @Input() clickable: boolean = false;
  @Input() selected: boolean = false;
  @Input() size;

  initials; string;
  backgroundColor: string;

  constructor() { }

  ngOnInit() {
   this.initials = this.generateInitials();
   this.backgroundColor = this.intToRGB(this.hashCode(this.student.firstName + this.student.lastName))

  }

  generateInitials(){
      return  this.student.firstName[0].toUpperCase() +  this.student.lastName[0].toUpperCase();
  }

   hashCode(str) { // java String#hashCode
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

   intToRGB(i){
    var c = (i & 0x00FFFFFF)
      .toString(16)
      .toUpperCase();

    return "00000".substring(0, 6 - c.length) + c;
  }

}
